import axios from 'axios'
import { Dispatch, SetStateAction } from 'react'
import 'regenerator-runtime/runtime'

class Postier{

    getHoraires(token:string,client:string,site:string,setHoraires, setErrors: Dispatch<SetStateAction<string[]>>){

        axios.get(`api-v0/${client.split(":")[0]}/${site.split(':')[0]}/exceptionalhours`,{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                setHoraires(res.data)
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "Les horaires exceptionelles ne peuvent pas être récupérées"])
        })

    }


}

export const postier = new Postier()